import type { Column } from '@tanstack/react-table'
import { Input } from '@/shared/components/ui/input'
import { X } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'

interface ColumnFilterProps<TData, TValue> {
  column: Column<TData, TValue>
  placeholder?: string
}

export function ColumnFilter<TData, TValue>({
  column,
  placeholder = 'Filtrar...',
}: ColumnFilterProps<TData, TValue>) {
  const filterValue = (column.getFilterValue() as string) ?? ''

  return (
    <div className="relative flex items-center gap-1">
      <Input
        placeholder={placeholder}
        value={filterValue}
        onChange={(e) => column.setFilterValue(e.target.value)}
        className="h-8 w-full max-w-xs"
      />
      {filterValue && (
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0 absolute right-1"
          onClick={() => column.setFilterValue('')}
        >
          <X className="h-3 w-3" />
        </Button>
      )}
    </div>
  )
}
